import axios from "@/axios";
import kitchensUrl from "@/apis/kitchens";

export default {
  fetchAll({ include_secrets, include_restaurants }) {
    return axios.get(`${kitchensUrl}/kitchens`, {
      params: {
        include_secrets,
        include_restaurants,
      },
    });
  },
};
